export default __webpack_public_path__ + "static/media/sideeffects@3x.526cc22d.jpg";